import useAgentHub from '@xbus/agent-hub'
import appsettings from '@/appsettings'

export default useAgentHub(appsettings.agentHubUrl)